import classes from './SlotItem.module.sass'
import { SlotItemInterface } from '../../../../../common/types/interfaces'
import { Button } from '../../../../../common/components/button/Button'
import { format } from 'date-fns'
import { SLOT_ITEM_ROUTE } from '../../../../../common/utils/constants'
import { ImageGallery } from '../../../../../common/components/imageGallery/ImageGallery'
import { Selected } from '../../../../../common/components/selected/Selected'
import { useSelector } from 'react-redux'
import { selectCurrentUser } from '../../../../../store/slices/currentUserSlice'
import { StatusComponent } from '../../../../../common/components/statusComponent/StatusComponent'
import { TypesSection } from '../../../../../common/components/typesSection/TypesSection'
import { shortenText } from '../../../../../common/utils/functions/shortenText'
import { selectDarkTheme } from '../../../../../store/slices/settingsSlice'

type Props = {
  item: SlotItemInterface
  toggleSelected: (item: SlotItemInterface) => void
}

export const SlotItem = ({ item, toggleSelected }: Props) => {
  const currentUser = useSelector(selectCurrentUser)
  const darkTheme = useSelector(selectDarkTheme)

  return (
    <div className={darkTheme ? classes.ContainerDark : classes.Container}>
      <div className={classes.ContentContainer}>
        <div className={classes.StatusAndSelected}>
          <Selected
            visible={Boolean(currentUser && currentUser.id !== item.userId)}
            selected={Boolean(item.selected?.find((el: any) => el.user_id === currentUser?.id))}
            onClick={() => toggleSelected(item)}
          />
          <StatusComponent item={item} />
        </div>
        <div className={classes.Name}>
          <span className={classes.Label}>Слот</span>
          {shortenText(item.name, 70)}
        </div>
        <div className={classes.Description}>
          <span className={classes.Label}>Описание</span>
          <div className={classes.Name}>{shortenText(item.description, 70)}</div>
        </div>
        {item.points && item.points[0].address && (
          <div className={classes.Address}>
            <span className={classes.Label}>Адрес</span>
            {item.points && item.points[0].address.value}
            {item.points && item.points[0].city && (
              <span className={classes.CityLabel}>{item.points[0].city.value}</span>
            )}
          </div>
        )}
        {item.points && !item.points[0].address && (
          <div className={classes.Address}>
            <span className={classes.Label}>Город</span>
            {item.points && item.points[0].city.value}
          </div>
        )}
        {item.points && item.points.length > 1 && item.points[item.points.length - 1].address && (
          <div className={classes.Address}>
            <span className={classes.Label}>Адрес</span>
            {item.points[item.points.length - 1].address.value}
            {item.points[item.points.length - 1].city && (
              <span className={classes.CityLabel}>
                {item.points[item.points.length - 1].city.value}
              </span>
            )}
          </div>
        )}
        {item.points &&
          !item.points[item.points.length - 1].address &&
          item.points.length > 1 &&
          item.points[item.points.length - 1].city && (
            <div className={classes.Address}>
              <span className={classes.Label}>Город</span>
              {item.points[item.points.length - 1].city.value}
            </div>
          )}
        {item.start_important && (
          <div className={classes.Time}>
            <span className={classes.Label}>Дата и время подачи</span>
            {format(item.startTime, 'dd.MM.yyyy HH:mm')}
          </div>
        )}
        {item.end_important && (
          <div className={classes.Time}>
            <span className={classes.Label}>Дата и время завершения</span>
            {format(item.endTime, 'dd.MM.yyyy HH:mm')}
          </div>
        )}
        <div className={classes.Cost}>
          <>
            <div className={classes.Label}>Ставка</div>
            <div>
              {item.cost
                ? `${new Intl.NumberFormat('ru-RU').format(Number(item.cost))} ₽`
                : 'Не указана'}
            </div>
          </>
        </div>
        <TypesSection item={item} />
      </div>
      <div className={classes.Id}>{item.id}</div>

      <div className={classes.Buttons}>
        <div className={classes.Button}>
          <Button small text="Подробнее" href={`${SLOT_ITEM_ROUTE}/${item.id}`} />
        </div>
      </div>
      <ImageGallery urls={item.files} small />
    </div>
  )
}
